import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {map, of, catchError} from 'rxjs';
import {SettingsService} from '../services/settings.service';
import {rNames} from '../r.names';

/** Раздел «Курсы» выключен админом — гасим роуты в 404. */
export const coursesEnabledGuard: CanActivateFn = () => {
  const settings = inject(SettingsService);
  const router = inject(Router);

  return settings.load().pipe(
    map(() => settings.coursesEnabled() === true
      ? true
      : router.parseUrl('/' + rNames.error404)),
    // API недоступен → не отменяем навигацию (иначе белый экран):
    // компонент покажет скелетон, как остальные публичные страницы.
    // Флаг — не секьюрити-граница: контент при лежащем API всё равно не загрузится.
    catchError(() => of(true))
  );
};
